"use strict";

exports.__esModule = true;
exports.FormGroup = void 0;

var _utils = require("@bydesign-ui/utils");

var _hooks = require("@bydesign-ui/hooks");

var _nestWatcher = require("../../../models/nest-watcher");

var _util = require("../util");

var _types = require("../types");

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

var DEFAULT_ERROR_PROCESSOR = function DEFAULT_ERROR_PROCESSOR(errors) {
  return errors[0];
};

var FormGroup = function (_Emitter) {
  _inheritsLoose(FormGroup, _Emitter);

  function FormGroup(form, scope, options) {
    var _this;

    _this = _Emitter.call(this) || this;
    _this.id = (0, _utils.guid)();
    _this.captureChildError = false;
    _this.errorProcessor = DEFAULT_ERROR_PROCESSOR;
    _this.errors = [];
    _this.valid = false;
    _this.msg = '';
    var _options$field = options.field,
        field = _options$field === void 0 ? '' : _options$field,
        _options$repeat = options.repeat,
        repeat = _options$repeat === void 0 ? false : _options$repeat,
        _options$defaultValue = options.defaultValue,
        defaultValue = _options$defaultValue === void 0 ? {} : _options$defaultValue;
    _this.form = form;
    _this.node = new _hooks.DomNode({
      type: _types.FormNodeType.GROUP,
      repeat: repeat,
      field: field,
      id: _this.id
    }, scope);
    _this.field = field;

    _this.init(defaultValue);

    return _this;
  }

  var _proto = FormGroup.prototype;

  _proto.updateOptions = function updateOptions(options) {
    var _options$field2 = options.field,
        field = _options$field2 === void 0 ? '' : _options$field2,
        _options$errorProcess = options.errorProcessor,
        errorProcessor = _options$errorProcess === void 0 ? DEFAULT_ERROR_PROCESSOR : _options$errorProcess,
        _options$captureChild = options.captureChildError,
        captureChildError = _options$captureChild === void 0 ? false : _options$captureChild;

    if (field !== this.field) {
      throw new Error('field should not be updated');
    }

    this.errorProcessor = errorProcessor;
    this.captureChildError = captureChildError;

    if (!captureChildError) {
      this.valid = true;
      this.msg = '';
    }
  };

  _proto.isField = function isField() {
    return false;
  };

  _proto.isGroup = function isGroup() {
    return true;
  };

  _proto.isRepeat = function isRepeat() {
    return false;
  };

  _proto.reset = function reset() {
    this.msg = '';
  };

  _proto.getGroupInfo = function getGroupInfo() {
    if (!this.captureChildError) {
      return {
        msg: '',
        valid: true,
        scope: this.node
      };
    }

    return {
      msg: this.msg,
      valid: this.valid,
      scope: this.node
    };
  };

  _proto.getNode = function getNode() {
    return this.node;
  };

  _proto.getPath = function getPath() {
    return _nestWatcher.NestWatcher.combineKeys((0, _util.getRelativeKeys)(this.node));
  };

  _proto.processValidateResult = function processValidateResult(id, error) {
    if (!this.captureChildError) {
      return;
    }

    var index = this.errors.findIndex(function (item) {
      return item.id === id;
    });
    var updated = false;

    if (error == null || error.valid) {
      if (index >= 0) {
        this.errors.splice(index, 1);
        updated = true;
      }
    } else if (index < 0) {
      this.errors.push({
        id: id,
        msg: error.msg
      });
      updated = true;
    } else if (this.errors[index].msg !== error.msg) {
      this.errors[index].msg = error.msg;
      updated = true;
    }

    if (updated) {
      var msg = this.errorProcessor(this.errors.map(function (item) {
        return item.msg;
      }));
      var valid = this.errors.length <= 0;

      if (msg !== this.msg || this.valid !== valid) {
        this.msg = msg;
        this.valid = valid;
        this.emit('repaint');
      }
    }
  };

  _proto.dispose = function dispose() {
    var _this2 = this;

    this.form.unregister(this);
    this.form.unwatch(this.id);
    this.node.getChildNodes().forEach(function (node) {
      return _this2.form.disposeNode(node);
    });
    this.node.remove();
  };

  _proto.init = function init(defaultValue) {
    this.form.register(this);

    if (this.field) {
      var value = this.form.getPathValue(_nestWatcher.NestWatcher.combineKeys((0, _util.getRelativeKeys)(this.node)));

      if (value == null) {
        this.form.setPathValue(_nestWatcher.NestWatcher.combineKeys((0, _util.getRelativeKeys)(this.node)), defaultValue, true);
      }
    }
  };

  return FormGroup;
}(_hooks.Emitter);

exports.FormGroup = FormGroup;